const navigationPlugin = {
	id: 'canvas.navigation',
	version: 1,
	commandVersion: 1,
	destinations: {
		'home.dashboard': {
			path: '/Dashboard',
		},
		'profile.dashboard': {
			path: '/template',
		},
		// Account Details - the signed-in admin's own profile, password, and
		// authentication settings. Distinct from `profile.dashboard` above,
		// which (despite the name) is the Global Profiles /template page.
		'account.dashboard': {
			path: '/profile',
		},
		// Canvas Settings. One page hosting several resources, the same way
		// /template hosts SSID Schedules and SSID Templates - so the page
		// belongs here and each resource owns only its own sections on it.
		'settings.dashboard': {
			path: '/system',
		},
		'settings.security': {
			path: '/system?tab=security',
		},
		// Maintenance. One page hosting several resources (Reports, Alarms,
		// Logs, Backup, Firmware) the same way /template hosts SSID
		// Schedules and SSID Templates - so the page belongs here and each
		// resource owns only its own sections on it.
		'maintenance.dashboard': {
			path: '/Maintenance',
		},
		// IO-Pass, Canvas's guest access product. Same shape as the two
		// above: one page hosting Configuration (captive portals, splash
		// pages, plans, approval) and Sessions, each of which owns its own
		// section rather than the page.
		'iopass.dashboard': {
			path: '/iopass',
		},
	},
};

export default navigationPlugin;
